import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Form } from '@unform/web';
import { isEmpty, isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Autocomplete, Combobox, InputText } from '~/components/Form';
import { t } from '~/helpers';
import api from '~/services/api';
import { storeOperacaoBatelada } from '~/store/modules/operacaobatelada/actions';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
}) {
  const dispatch = useDispatch();
  const [posto, setPosto] = useState(0);
  const [tanqueVirtual, setTanqueVirtual] = useState(0);
  const [calculodensidadeproduto, setCalculoDensidadeProduto] = useState(0);
  const [densidadeobs, setDensidadeObs] = useState(0.0);
  const [temperaturaobs, setTemperaturaObs] = useState(0.0);
  const [densidade20, setDensidade20] = useState(0.0);
  const [densidade20Frt, setDensidade20Frt] = useState('');

  const handleGetPosto = React.useCallback((id, type) => {
    setPosto(id);
    if (reference) {
      if (reference.current) {
        reference.current.setErrors({});
        reference.current.setFieldValue('densidadeobsbatelada', '');
        reference.current.setFieldValue('temperaturaobsbatelada', '');
        document.getElementById('densidade20batelada').value = '';
      }
    }
    setDensidadeObs('');
    setTemperaturaObs('');
    setDensidade20('');
    setDensidade20Frt('');
  }, []);

  const { client } = useSelector((state) => state.user.profile);

  const { loading, find, params } = useSelector(
    (state) => state.operacaobatelada
  );

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        idposto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        idtanquevirtual: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        idtanquefisico: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        densidadeobsbatelada: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          // .integer(t('s.geral.validacao.deveserinteiro'))
          .moreThan(-1, t('s.geral.validacao.valorminimo').replace('%s', 0))
          .lessThan(10, t('s.geral.validacao.valormaximo').replace('%s', 10))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        temperaturaobsbatelada: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          // .integer(t('s.geral.validacao.deveserinteiro'))
          .moreThan(-1, t('s.geral.validacao.valorminimo').replace('%s', 0))
          .lessThan(101, t('s.geral.validacao.valormaximo').replace('%s', 100))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      });

      let objParam = { ...param };

      let { densidadeobsbatelada, temperaturaobsbatelada } = param;
      if (densidadeobsbatelada) {
        densidadeobsbatelada = String(densidadeobsbatelada).replace(',', '.');
      }

      if (temperaturaobsbatelada) {
        temperaturaobsbatelada = String(temperaturaobsbatelada).replace(
          ',',
          '.'
        );
      }

      objParam = {
        ...param,
        densidadeobsbatelada,
        temperaturaobsbatelada,
      };

      await schema.validate(objParam, {
        abortEarly: false,
      });

      const validationErrors = reference.current.getErrors();
      if (!isEmpty(validationErrors)) {
        const erros = Object.values(validationErrors);
        if (isArray(erros)) erros.map((e) => toast.error(t(e)));
        return;
      }

      if (String(densidade20) === '' || densidade20 === 0) {
        toast.error(
          `${t('s.operacao.batelada.densidade20')}: ${t(
            's.geral.validacao.campoobrigatorio'
          )}`
        );
        return;
      }
      const objSend = {
        idbatelada: 0,
        idcliente: client,
        idposto: objParam.idposto,
        idtanquevirtual: objParam.idtanquevirtual,
        idtanquefisico: objParam.idtanquefisico,
        idusuario: 0,
        datahorainiciobatelada: null,
        datahorafinalbatelada: null,
        densidadeobsbatelada: Number(objParam.densidadeobsbatelada),
        temperaturaobsbatelada: Number(objParam.temperaturaobsbatelada),
        densidade20batelada: densidade20 || 0.0,
        tipobatelada: '0',
      };

      dispatch(storeOperacaoBatelada(objSend, params));
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  const handleGetConverteDensidadePara20Graus = React.useCallback(async () => {
    if (Number(densidadeobs > 0) && Number(temperaturaobs > 0)) {
      try {
        const response = await api.get(
          `/calculodensidades/converteDensidadePara20Graus/${densidadeobs}/${temperaturaobs}/${calculodensidadeproduto}`
        );
        let valor20 = String(response.data.densidade20);
        valor20 = valor20.replace('.', ',');
        setDensidade20Frt(valor20);
        setDensidade20(response.data.densidade20);
        if (
          !response.data.temperaturaAmbienteValida ||
          !response.data.densidade20Valida ||
          !response.data.densidadeAmbienteValida
        ) {
          let validationErrorsnovo = {};

          if (response.data.msgErroDensidadeAmbiente) {
            validationErrorsnovo = {
              ...validationErrorsnovo,
              densidadeobsbatelada: response.data.msgErroDensidadeAmbiente,
            };
          }

          if (response.data.msgErroTemperaturaAmbiente) {
            validationErrorsnovo = {
              ...validationErrorsnovo,
              temperaturaobsbatelada: response.data.msgErroTemperaturaAmbiente,
            };
          }

          const validationErrors = {
            densidadeobsbatelada: response.data.msgErroDensidadeAmbiente,
            temperaturaobsbatelada: response.data.msgErroTemperaturaAmbiente,
          };

          if (reference) {
            if (reference.current) {
              reference.current.setErrors(validationErrorsnovo);
            }
          }
        } else if (reference) {
          if (reference.current) {
            reference.current.setErrors({});
          }
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        // setLoadingLocal(false);
      }
    }
  }, [densidadeobs, temperaturaobs, calculodensidadeproduto]);

  useEffect(() => {
    if (Number(densidadeobs) > 0 && Number(temperaturaobs) > 0) {
      handleGetConverteDensidadePara20Graus();
    }
  }, [densidadeobs, temperaturaobs, tanqueVirtual]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Autocomplete
            name="idposto"
            label="codigonomeposto"
            url="postoscomboioscontrole20graus"
            unique="idposto"
            title={t('s.geral.postocomboio')}
            disabled={!create}
            getValue={({ idposto, tipoposto }) =>
              handleGetPosto(idposto, tipoposto)
            }
          />
          <Combobox
            name="idtanquevirtual"
            label="tanquevirtualprodutotanquevirtual"
            url="tanquesvirtuais"
            unique="idtanquevirtual"
            title={t('s.configuracao.tanquefisico.idtanquevirtual')}
            disabled={!posto || !create}
            hiddens={[{ name: 'calculodensidadeproduto' }]}
            params={{
              wherefield: ['idposto', 'tipoproduto', 'calculodensidadeproduto'],
              valuewherefield: [
                !isEmpty(find) ? find.idposto : posto,
                'C',
                '0',
              ],
              typewherefield: ['EQUALS', 'EQUALS', 'NEQUALS'],
            }}
            getValue={(value) => {
              value.idtanquevirtual && setTanqueVirtual(value.idtanquevirtual);
              value.calculodensidadeproduto &&
                setCalculoDensidadeProduto(value.calculodensidadeproduto);
            }}
          />
          <Combobox
            name="idtanquefisico"
            disabled={!create || !posto || !tanqueVirtual}
            label="codigotanquefisico"
            url="tanquesfisicos"
            unique="idtanquefisico"
            title={t('s.configuracao.tanquefisico.idtanquefisico')}
            params={{
              wherefield: ['idposto', 'idtanquevirtual'],
              valuewherefield: [
                !isEmpty(find) ? find.idposto : posto,
                tanqueVirtual,
              ],
              typewherefield: ['EQUALS', 'EQUALS'],
              fieldlist:
                'idposto, idtanquevirtual, idtanquefisico, codigotanquefisico',
            }}
          />

          <InputText
            name="densidadeobsbatelada"
            label={t('s.operacao.batelada.densidadeobs')}
            mask="9,9999"
            placeholder=""
            getValue={(value) => {
              if (value) {
                let val = String(value);
                val = val.replace(',', '.');
                setDensidadeObs(Number(val));

                if (reference) {
                  if (reference.current) {
                    reference.current.setFieldValue(
                      'densidadeobsbatelada',
                      String(val)
                    );
                  }
                }
              } else {
                const validationErrors = {
                  ...reference.current.getErrors(),
                  densidadeobsbatelada: '',
                };
                if (reference) {
                  if (reference.current) {
                    reference.current.setErrors(validationErrors);
                  }
                }
              }
            }}
          />

          <InputText
            name="temperaturaobsbatelada"
            label={t('s.operacao.batelada.temperaturaobs')}
            mask="99,9"
            placeholder=""
            getValue={(value) => {
              if (value) {
                let val = String(value);
                val = val.replace(',', '.');
                setTemperaturaObs(Number(val));

                if (reference) {
                  if (reference.current) {
                    reference.current.setFieldValue(
                      'temperaturaobsbatelada',
                      String(val)
                    );
                  }
                }
              } else {
                const validationErrors = {
                  ...reference.current.getErrors(),
                  temperaturaobsbatelada: '',
                };
                if (reference) {
                  if (reference.current) {
                    reference.current.setErrors(validationErrors);
                  }
                }
              }
            }}
          />

          <Input
            name="densidade20batelada"
            label={t('s.operacao.batelada.densidade20')}
            disabled
            value={densidade20Frt > '' ? densidade20Frt : ''}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
